import { useTranslation } from 'react-i18next';

export default function AboutIntro() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100/70">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
              {t('about_intro_title1')}
              <br />
              {t('about_intro_title2')}
            </h2>
            <p className="text-sm text-foreground-600 mt-4">{t('about_intro_subtitle')}</p>
            <p className="text-sm text-foreground-700 leading-relaxed mt-6">
              {t('about_intro_paragraph1')}
            </p>
            <p className="text-sm text-foreground-700 leading-relaxed mt-4">
              {t('about_intro_paragraph2')}
            </p>
          </div>
          <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20workspace%20with%20multiple%20monitors%20displaying%20entertainment%20news%2C%20warm%20lighting%2C%20professional%20journalism%20environment%2C%20clean%20minimalist%20office%2C%20team%20collaboration%20setup%2C%20soft%20evening%20light%20through%20windows%2C%20creative%20atmosphere&width=900&height=675&seq=about-intro-01&orientation=landscape"
              alt="51吃瓜编辑部工作场景"
              title="51吃瓜编辑部工作场景"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}